export type LinkPreviewApiResponse = {
  title: string;
  description: string;
  image: string;
  canonical?: string;
  url: string;
};

export const URL_PREVIEW_QUERY_KEY = "url-preview";

export const URL_PREVIEW_CACHE_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 14;
export const URL_PREVIEW_REVALIDATE_SECONDS = 60 * 60 * 24 * 7;
export const URL_PREVIEW_STALE_WHILE_REVALIDATE_SECONDS = 60 * 60 * 24 * 30;

export const URL_PREVIEW_CACHE_CONTROL = [
  "public",
  `s-maxage=${URL_PREVIEW_REVALIDATE_SECONDS}`,
  `stale-while-revalidate=${URL_PREVIEW_STALE_WHILE_REVALIDATE_SECONDS}`,
].join(", ");

export const normalizeUrlPreviewTarget = (value: string) => {
  const url = new URL(value.trim());

  if (url.protocol !== "http:" && url.protocol !== "https:") {
    throw new Error("Only HTTP and HTTPS URLs can be previewed");
  }

  url.hash = "";

  return url.toString();
};

export const createEmptyUrlPreview = (url: string): LinkPreviewApiResponse => ({
  title: "",
  description: "",
  image: "",
  canonical: url,
  url,
});
